import React from 'react';
import { DropdownButtonProps } from '../components/dropdown-button/dropdown-button';
import { DropdownOption } from '../dropdown';
import useDropdownPosition from './use-dropdown-position';

const useDropdownState = ({ dropDirection, menuAlign, autoClose, onSelect }: Partial<DropdownButtonProps>) => {
    const { isOpen, setIsOpen, menuRef, styles, isCalculating } = useDropdownPosition(dropDirection, menuAlign);

    const onItemSelect = (option: DropdownOption | undefined, e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        if (autoClose === 'select' || autoClose === 'select-outside') {
            setIsOpen(false);
        }

        if (onSelect) {
            const target = e.target as HTMLElement;
            const eventKey = target.getAttribute('data-event-key') || null;

            onSelect(option, eventKey, e);
        }
    };

    return {
        isOpen,
        setIsOpen,
        onItemSelect,
        menuRef,
        styles,
        isCalculating
    };
};

export default useDropdownState;
